import { Button } from "@aqar-app/aqar-design-system";
import Link from "next/link";
import { useRouter } from "next/router";
import ReactGA from "react-ga";
import classnames from "classnames/bind";
import LinksWidget, { Col } from "./LinksWidget";
import DeferredIcon from "../../../components/deferred-icon/DeferredIcon";
import { linksList1, linksList2, linksList3, linksList4 } from "../footerLinks";
import styles from "./footer.module.scss";

const cx = classnames.bind(styles);

const Footer = () => {
  const router = useRouter();
  const { iframe } = router?.query;

  return (
    <div className={cx("footer", { iframe: iframe === "1" })}>
      <div className={styles.top}>
        <div className={styles.downloadSection}>
          <Link href="/" passHref>
            <div className={styles.logo}>
              <DeferredIcon
                type="AqarLogo-colored"
                alt="aqar logo"
                width={100}
                height={100}
              />
              <span className={styles.subtitle}>معك في رحلة العمر</span>
            </div>
          </Link>
          <div className={styles.btns}>
            <Button
              priority="primary"
              className={styles.footerBtn}
              suffixIcon="Android"
              iconColor="colored"
              link="https://play.google.com/store/apps/details?id=fm.aqar"
              label=" Android"
              onClick={() => {
                ReactGA.event({
                  category: "download_android_footer",
                  action: "Download Android app from footer",
                });
              }}
            />
            <Button
              priority="primary"
              className={styles.footerBtn}
              suffixIcon="iPhone"
              link="https://apps.apple.com/sa/app/id879992882"
              label="iPhone"
              onClick={() => {
                ReactGA.event({
                  category: "download_iphone_footer",
                  action: "Download iPhone app from footer",
                });
              }}
            />
            <Button
              priority="primary"
              className={styles.footerBtn}
              suffixIcon="Huawei"
              link="https://appgallery.huawei.com/app/C100162543"
              label="AppGallery"
              onClick={() => {
                ReactGA.event({
                  category: "download_huawei_footer",
                  action: "Download Huawei app from footer",
                });
              }}
            />
          </div>
        </div>
        <LinksWidget title="خيارات البحث">
          <Col links={linksList1} />
          <Col links={linksList2} />
        </LinksWidget>
        <LinksWidget title="روابط سريعة">
          <Col links={linksList3} />
          <Col links={linksList4} />
        </LinksWidget>
      </div>
      <div className={styles.bottom}>
        <div className={styles.rightSide}>
          <div className={styles.socialIcon}>
            <DeferredIcon
              alt="Fb"
              type="Facebook"
              className={styles.icon}
              onClick={() =>
                window.open("https://www.facebook.com/aqar.app.50", "_blank")
              }
              width={25}
              height={25}
            />
          </div>
          <div className={styles.socialIcon}>
            <DeferredIcon
              alt="linkedin"
              type="Linkedin"
              className={styles.icon}
              onClick={() =>
                window.open(
                  "https://www.linkedin.com/company/aqarfm/about/",
                  "_blank"
                )
              }
              width={25}
              height={25}
            />
          </div>
          <div className={styles.socialIcon}>
            <DeferredIcon
              alt="twitter"
              type="Twitter"
              className={styles.icon}
              onClick={() =>
                window.open("https://twitter.com/aqarapp", "_blank")
              }
              width={25}
              height={25}
            />
          </div>
          <div className={styles.socialIcon}>
            <DeferredIcon
              alt="instagram"
              type="Instagram"
              className={styles.icon}
              onClick={() =>
                window.open("https://www.instagram.com/aqarapp", "_blank")
              }
              width={25}
              height={25}
            />
          </div>
          <div className={styles.socialIcon}>
            <DeferredIcon
              alt="youtube"
              type="Youtube"
              className={styles.icon}
              onClick={() =>
                window.open(
                  "https://www.youtube.com/channel/UCxWf_zM_FSEBaH5Z_4K8oaA/videos",
                  "_blank"
                )
              }
              width={25}
              height={25}
            />
          </div>
          <div className={styles.socialIcon}>
            <DeferredIcon
              alt="snapchat"
              type="Snapchat"
              className={styles.icon}
              onClick={() =>
                window.open("https://www.snapchat.com/add/aqarapp", "_blank")
              }
              width={25}
              height={25}
            />
          </div>
        </div>
        <div className={styles.leftSide}>
          <DeferredIcon
            alt="vat"
            type="vat_2"
            className={styles.icon}
            onClick={() =>
              window.open(
                "https://assets.aqar.fm/files/VAT-Certificate.pdf",
                "_blank"
              )
            }
            width={40}
            height={40}
          />
          <DeferredIcon
            alt="rega"
            type="REGA-License"
            ext="png"
            className={styles.icon}
            onClick={() =>
              window.open("https://bit.ly/aqar-REGA-license", "_blank")
            }
            width={40}
            height={40}
          />
        </div>
      </div>
      <div className={styles.copyrights}>
        كافة الحقوق محفوظة لتطبيق عقار {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default Footer;
